






























































































































































































































































import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import ContestacaoMedicaStore from '@/components/ContestacaoMedica/Store/ContestacaoMedicaStore'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import { isRolesValid, groupCollectionByField, timeout } from '@/utils/common'
import { ContestacaoMedica, ContestacaoMedicaMensagem, TipoUsuarioEnum, RequestMessage, TipoMensagemEnum } from '@/types/_'
import moment from 'moment'

@Component

export default class ComponentModalAutorizacaoContestacaoMedica extends Vue {
  @Prop() tipoUsuario: string

  $refs!: { formJustificativaContestacao: any }
  formJustificativaContestacao: any = {
    valid: true,
    justificativa: '',
  }

  formJustificativaContestacaoRules: any = {
    justificativa: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  loadingContestarNovamente: boolean = false
  dialogContestacao: boolean = false

  async contestarNovamente() {
    this.loadingContestarNovamente = true
    if (this.$refs.formJustificativaContestacao.validate()) {
      this.getTexto = this.formJustificativaContestacao.justificativa
      await this.addMensagemManager(null, '', '', TipoMensagemEnum.Texto)
      this.getShowModal = false
    }
    this.loadingContestarNovamente = false
  }

  @Watch('dialogContestacao')
  onChangeDialogContestacao(value: boolean) {
    if (!value) {
      this.formJustificativaContestacao.valid = true
      this.formJustificativaContestacao.justificativa = ''
      this.$refs.formJustificativaContestacao.resetValidation()
      this.loadingContestarNovamente = false
    }
  }

  dial: boolean = false
  texto: string = ''
  inputFiles: any[] = []
  msgLoader: boolean = false

  get dialog() {
    return this.dial
  }

  set dialog(value: boolean) {
    this.dial = value
  }

  get msgLoading() {
    return this.msgLoader
  }

  set msgLoading(value: boolean) {
    this.msgLoader = value
  }

  get getContestacaoStore() {
    return getModule(ContestacaoMedicaStore, this.$store)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getShowModal() {
    const show = this.getContestacaoStore.modal.contestacaoMedica
    this.toggleHtmlOverflow(show)
    return show
  }

  set getShowModal(value: boolean) {
    this.getContestacaoStore.clearContestacaoMedica()
    this.getContestacaoStore.setShowModalContestacaoMedica(value)
  }

  get getContestacaoMedica() {
    return this.getContestacaoStore.contestacaoMedica
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get getMensagens() {
    return this.getContestacaoStore.contestacaoMedica.mensagens
      ? groupCollectionByField(this.getContestacaoStore.contestacaoMedica.mensagens)
      : []
  }

  get getTexto() {
    return this.texto
  }

  set getTexto(value: string) {
    this.texto = value
  }

  async getUser() {
    const user = await Auth.getUser()
    return user
  }

  clearTexto() {
    this.getTexto = ''
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('l_main_scrollto')
    const option: ScrollToOptions = {
      behavior: 'smooth',
      left: 0,
      top: ele[0].scrollHeight + 1000,
    }

    ele[0].scrollTo(option)
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  formatHour(value: string) {
    return moment(value).format('HH:mm')
  }

  formatDate(value: string) {
    return moment(value).format('DD/MM/YYYY')
  }

  async addMensagem() {
    if (this.getTexto) {
      this.msgLoading = true
      await this.addMensagemManager(null, '', '', TipoMensagemEnum.Texto)
      this.msgLoading = false
    }
  }

  async inputFile(newFile, oldFile) {
    const requestMessage = new RequestMessage()

    this.setLoadingRequest(requestMessage.status, requestMessage.post)
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('documentos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm')

    const { hospitalId } = this.getSolicitacaoPendenciaStore.agendamentoMedico
    const request = await this.getContestacaoStore.uploadDocumento({ hospitalId, formData: form })

    if (request.success) {
      const result = request.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result
      await this.addMensagemManager(documentoId, url, nomeArquivo, TipoMensagemEnum.Documento)
    }

    this.clearLoadingRequest()
  }

  async addMensagemManager(documentoId, url, nomeArquivo, tipoMensagem) {
    const time = moment().format('YYYY-MM-DDTHH:mm')
    const mensagemHospital = this.tipoUsuario === 'hospital'
    const solicitacaoId = this.getSolicitacaoStore.solicitacao.id

    const contestacaoMedicaMensagem: ContestacaoMedicaMensagem = {
      id: '',
      dataEnvio: time,
      tipoMensagem,
      mensagemHospital,
      texto: this.getTexto,
      documentoId,
      url,
      nomeArquivo,
    }

    const response = await this.getContestacaoStore.enviarMensagem({ solicitacaoId, contestacaoMedicaMensagem })

    if (response.data && response.data.solicitacao) {
      await timeout(100)
      this.getSolicitacaoPendenciaStore.setAgendamentoMedico(response.data.solicitacao)
    }

    if (response.data && response.data.acaoMedicoResponse) {
      await timeout(100)
      this.getSolicitacaoPendenciaStore.setAgendamentoMedico(response.data.acaoMedicoResponse.solicitacao)
    }

    this.clearTexto()
    this.scrollToMensagem()
  }

  async responder(action: string) {
    const requestMessage = new RequestMessage()
    this.setLoadingRequest(true, requestMessage.post)
    const response = await this.getContestacaoStore[action]()
    if (response.data && response.data.solicitacao) {
      this.loadAgendamento()
    }
    this.clearTexto()
    this.getContestacaoStore.setShowModalContestacaoMedica(false)
    this.clearLoadingRequest()
  }

  @Emit('loadAgendamento')
  loadAgendamento() { }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }

  updated() {
    this.scrollToMensagem()
  }
}
